import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../../assets/trust-img1.png"
import img2 from "../../assets/trust-img2.png"
import img3 from "../../assets/trust-img3.png"
import img1Top from "../../assets/trust-img1-top.png"
import img2Top from "../../assets/trust-img2-top.png"
import img3Top from "../../assets/trust-img3-top.png"
import { div } from "framer-motion/client";

const Trustslider = () => {

    const [slidesToShow, setSlidesToShow] = useState(2);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 650) {
                setSlidesToShow(1);
            } else {
                setSlidesToShow(2);
            }
        };

        handleResize(); // set initially

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const settings = {
        dots: true,
        arrows: false,
        autoplay: true,
        // infinite: true,
        speed: 900,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    const trustData = [
        {
            id: 1,
            title: "DRDO",
            img: img1,
            imgTop: img1Top,
            bg: "#DAECFF",
            border: "1px solid #0351A1"
        },
        {
            id: 2,
            title: "Travel Trial",
            img: img2,
            imgTop: img2Top,
            bg: "#FFEADE",
            border: "1px solid #F36D24"
        },
        {
            id: 3,
            title: "Railtel",
            img: img3,
            imgTop: img3Top,
            bg: "#DBF3FF",
            border: "1px solid #0093DD"
        }
    ]
    return (
        <Slider {...settings} className="trustslider">
            {trustData?.map((item) => (
                <div  key={item.id}>

                <div className="trstbox" style={{ backgroundColor: item.bg, border: item.border }}>
                    <img className="trstimg" src={item.img} alt={item.title} />
                    <img className="trsttop" src={item.imgTop} alt={item.title} />
                </div>
                </div>
            ))}
        </Slider>
    )
}

export default Trustslider